import { ServiceTypes } from 'constants/ServiceTypes';
import { HotkeyBadge } from 'pages/Tagging/components/HotkeyBadge/HotkeyBadge';
import React, { useEffect } from 'react';
import { HotkeyService } from 'services/helper-services/HotkeyService';
import { useInjection } from 'services/ioc/ioc.react';
import { OptionText } from './BottomBarOptionStyles';

interface IProps {
  onPressHotkeyCallback: () => void;
  displayName: string;
  keyCode: number;
  label: string;
  hotkey: string;
  className: string;
  ['data-testid']?: string;
}

const BottomBarOption: React.FC<IProps> = (props) => {
  const { onPressHotkeyCallback, displayName, keyCode, label, hotkey, className, ...rest } = props;
  const hotkeyService = useInjection<HotkeyService>(ServiceTypes.HotkeyService);

  const onPressHotkey = (event: KeyboardEvent): boolean => {
    if (onPressHotkeyCallback) {
      onPressHotkeyCallback();
    }
    return false;
  };

  useEffect(() => {
    hotkeyService.subscribe(keyCode, onPressHotkey, displayName);

    return () => {
      hotkeyService.unsubscribe(displayName);
    };
  }, [onPressHotkeyCallback]);

  return (
    <div className={className} onClick={onPressHotkeyCallback} {...rest}>
      <OptionText>{label}</OptionText>
      <HotkeyBadge hotkey={hotkey} />
    </div>
  );
};

export default BottomBarOption;
